import { Redirect, RouteChildrenProps } from 'react-router'

import { isEmpty } from 'lodash'

import LazyImport from 'src/HOC/LazyImport'
import {
  AUTH_REDIRECTED_URLS,
  PATIENT_SEARCH_ACCESS
} from 'src/utils/constants'

const PatientSearch = LazyImport(() => import('./'))

const PatientRootRedirect = (
  props: RouteChildrenProps & { patientUuid: string; accessType: number }
) => {
  const { pathname } = props.location

  if (isEmpty(props.patientUuid)) {
    if (PATIENT_SEARCH_ACCESS.includes(props.accessType)) {
      return <PatientSearch />
    }

    if (AUTH_REDIRECTED_URLS.includes(pathname)) {
      return <Redirect to="/not-found" />
    }
  }

  return <Redirect to={`/patient/${props.patientUuid}`} />
}

export default PatientRootRedirect
